import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class LoginService {

  private baseUrl = environment.API_BASE_URL;

  constructor(private http: HttpClient) {}

  login(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}login`, data);
  }
  
  logout(data: any): Observable<any> {
  return this.http.post(`${this.baseUrl}logout`, data);
}


}